var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cc-container',{staticClass:"invoice"},[_c('cc-header-nav',{attrs:{"title":"发票预览","url":"#/invoice/list"}}),_c('cc-main',[_c('div',{attrs:{"id":"demo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }